import React from 'react';
import { CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CTAButton } from '../CTAButton';
import { PriceBlock } from '../PriceBlock';
import { HERO_MOCKUP, OFFER_ITEMS, PRODUCT } from '../../data/catio';

/**
 * First price reveal. The hero CTA scrolls here (#offer).
 * This CTA — unlike the hero one — opens the real checkout.
 * `#offer-price` and `#offer-cta` drive the mobile sticky bar.
 */
export function OfferSection() {
  return <section aria-labelledby="offer-title" className="bg-ink py-12 sm:py-20" data-id="element-215" data-mp="1pgexz1yvlaa">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-8" data-id="element-216" data-mp="3sw9ekyh43ccp">
        <SectionHeading id="offer-title" tone="dark" align="center" eyebrow="The complete collection" title="Get the Complete CATIO READY™ Collection" data-id="element-217" data-mp="3sug8bkaeuu58" />

        <div className="mt-8 overflow-hidden rounded-[22px] bg-paper shadow-[0_40px_80px_-40px_rgba(0,0,0,0.8)] sm:mt-10 lg:grid lg:grid-cols-[1fr_1fr]" data-id="element-218" data-mp="3ex00c4cgusbd">
          <div className="flex items-center justify-center border-b border-line bg-stone px-4 pb-4 pt-6 lg:border-b-0 lg:border-r lg:px-8 lg:py-10" data-id="element-219" data-mp="1aqfsgd6bu023">
            <img src={HERO_MOCKUP.src} alt={HERO_MOCKUP.alt} width={HERO_MOCKUP.width} height={HERO_MOCKUP.height} loading="lazy" decoding="async" className="h-[230px] w-auto max-w-full object-contain drop-shadow-[0_18px_26px_rgba(28,31,28,0.18)] sm:h-[300px] lg:h-auto lg:max-h-[480px]" data-id="element-220" data-mp="10u4d1ebfwu3f" />
          </div>

          <div className="px-5 pb-7 pt-6 sm:px-10 sm:pb-10 sm:pt-9" data-id="element-221" data-mp="1kid8bx8a5g75">
            <p className="wordmark text-[1.7rem] text-ink" data-id="element-222" data-mp="1ojf6eaqgnm7j">
              Catio <span className="text-ember" data-id="element-223" data-mp="1ohueksvj6hdd">Ready</span>™
            </p>
            <p className="mt-1.5 text-[0.92rem] text-graphite" data-id="element-224" data-mp="91lrqq6bk0mq">{PRODUCT.descriptor}</p>

            <ul className="mt-5 grid gap-2.5" data-id="element-225" data-mp="d4rxlwpirpso">
              {OFFER_ITEMS.map(item => {
              const free = item.includes('FREE');
              return <li key={item} className="flex items-center gap-3 text-[1rem] font-semibold text-ink" data-id="element-226" data-mp="2arudfni5p32d">
                    <span className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${free ? 'border border-ember text-ember' : 'bg-ink text-cream'}`} aria-hidden data-id="element-227" data-mp="25zjdwlrbvjac">
                      <CheckIcon className="h-3 w-3" strokeWidth={3} data-id="element-228" data-mp="1rzrta26b34nd" />
                    </span>
                    {free ? <span data-id="element-229" data-mp="1n4314jwm8q13">
                        {item.replace(' FREE', '')} <span className="text-ember" data-id="element-230" data-mp="1i4gni9cvl7rr">FREE</span>
                      </span> : item}
                  </li>;
            })}
            </ul>

            {/*
              #offer anchor sits on the purchase block itself (price + buy button), so the
              hero CTA lands with both on screen. The scroll margin (added to the page's
              sticky-header padding) roughly centers this block in the viewport.
             */}
            <div id="offer" style={{
            scrollMarginTop: 'max(1rem, calc(50svh - 11rem))'
          }} data-id="element-231" data-mp="3tslidsy3av2v">
              <div className="mt-6 border-t border-line pt-6" data-id="element-232" data-mp="2jfp3j3tr57k">
                <PriceBlock id="offer-price" data-id="element-233" data-mp="320e2iuqermpj" />
                <p className="mx-auto mt-4 max-w-[34ch] text-center text-[0.92rem] leading-snug text-graphite" data-id="element-234" data-mp="321fb8sjybx43">
                  40 designs. One complete library. Ready to become part of your next client
                  project.
                </p>
                <p className="mt-2 flex items-center justify-center gap-1.5 text-[0.84rem] font-semibold text-ink" data-id="element-235" data-mp="3g05aadqc06v3">
                  <ShieldCheckIcon className="h-4 w-4 text-ember" aria-hidden data-id="element-236" data-mp="q9a343zvqzte" />
                  Commercial build rights included
                </p>
              </div>

              <CTAButton id="offer-cta" label="Get CATIO READY™ Now" size="lg" className="mt-6 w-full" data-id="element-237" data-mp="2451nuka22a4z" />

              <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-[0.84rem] text-graphite" data-id="element-238" data-mp="2d69np6s7zj16">
                <li className="flex items-center gap-1.5" data-id="element-239" data-mp="286dfswgej7gc">
                  <LockIcon className="h-3.5 w-3.5 text-wood" aria-hidden data-id="element-240" data-mp="2n4pe17jfao9m" /> Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-241" data-mp="2i5uid50cx583">
                  <ZapIcon className="h-3.5 w-3.5 text-wood" aria-hidden data-id="element-242" data-mp="2i5chfv2r22tu" /> Instant digital access
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}